<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <div
        class="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
      >
        <CategoryInstanceTableHeader title="category instance" />
        <BannerNotification />
        <div
          v-if="categoryLoading.pageLoading"
          class="bg-white w-full flex flex-col py-10 justify-center items-center"
        >
          <!-- https://gannon.tv/intro -->
          <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
          <h3>Loading...</h3>
        </div>
        <CategoryInstanceTable
          v-if="filteredCategoryInfo.length && !categoryLoading.pageLoading"
        />
        <p
          v-if="!filteredCategoryInfo.length && !categoryLoading.pageLoading"
          class="flex items-center justify-center py-5"
        >
          No Category Name Found...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import CategoryInstanceTable from "@/components/ComponentModule/InstanceTable/CategoryInstanceTable";
import CategoryInstanceTableHeader from "@/components/ComponentModule/InstanceTable/CategoryInstanceTableHeader";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";

export default {
  name: "CategoryPageInstanceList",
  components: {
    CategoryInstanceTableHeader,
    CategoryInstanceTable,
    BannerNotification
  },
  computed: {
    ...mapGetters([
      "filteredCategoryInfo",
      "categoryLoading",
      "getAllComponent",
      "getRegion"
    ])
  },
  mounted() {
    if (this.getAllComponent.length) {
      this.$store.dispatch(Actions.FETCH_EXIST_CATEGORY, {
        region: this.getRegion,
        categoryId: this.getComponentId("abi_category")
      });
    }
  },
  watch: {
    "getAllComponent.length"() {
      if (this.getAllComponent.length) {
        this.$store.dispatch(Actions.FETCH_EXIST_CATEGORY, {
          region: this.getRegion,
          categoryId: this.getComponentId("abi_category")
        });
      }
    }
  },
  methods: {
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
